/* eslint-disable arrow-parens */
import { SET_TRIP, SET_TRAVELER_STATUS } from './types'

export const setTrip = (trip) => async (dispatch) => {
  dispatch({ type: SET_TRIP, payload: trip })
}
export const setTravelerStatus = (status) => async (dispatch) => {
  dispatch({ type: SET_TRAVELER_STATUS, payload: status })
}
